import { EncrDecr } from './encr-decr-service';

export interface MoengageConfig {
  enabled: boolean;
  appId: string;
  payzappCookiename: string;
  mycardsCookiename: string;
  debugMode: 1 | 0;
}

export interface ProgramConfig {
  program: string;
  subProgram: string;
}

export interface CustomerInfo {
  customer_id: string | any;
  mobile: string | any;
  [key: string]: any;
}

export interface Encryption {
  enabled: boolean;
  encryptionKey: string | null;
}

export class ConfigService {
  private static config: {
    authApi?: string;
    cookieApi?: string;
    cmsApi?: string;
    cardFaciaCdnUrl?: string;
    moengage?: MoengageConfig;
    customerInfo?: CustomerInfo;
    programConfig?: ProgramConfig;
    cookieConsentName?: string;
    sessionSharingDomain?: boolean;
    googleAnalyticsKey?: string;
    sessionCheckLoginPath?: string;
    encryption?: Encryption;
  } = {};

  static setConfig(
    cfg: Partial<{
      authApi: string;
      cookieApi: string;
      cmsApi: string;
      cardFaciaCdnUrl: string;
      moengage: MoengageConfig;
      customerInfo: any;
      programConfig: ProgramConfig;
      cookieConsentName: string;
      sessionSharingDomain?: boolean;
      googleAnalyticsKey?: string;
      sessionCheckLoginPath?: string;
      encryption?: Encryption;
    }>
  ) {
    ConfigService.config = { ...ConfigService.config, ...cfg };
    EncrDecr.setPublicKeyPem(cfg.encryption?.encryptionKey || '');
  }

  static get authApiUrl(): string {
    return ConfigService.config.authApi || '';
  }

  static get cmsApiUrl(): string {
    return ConfigService.config.cmsApi || '';
  }

  static get cardFaciaCdnUrl(): string {
    return ConfigService.config.cardFaciaCdnUrl || '';
  }

  static get moengage(): MoengageConfig | undefined {
    return ConfigService.config.moengage;
  }

  static get customerInfo(): any {
    return ConfigService.config.customerInfo;
  }

  static get programConfig(): ProgramConfig | undefined {
    return ConfigService.config.programConfig;
  }

  static get cookieConsentName(): string | undefined {
    return ConfigService.config.cookieConsentName;
  }

  static get cookieApiUrl(): string | undefined {
    return ConfigService.config.cookieApi;
  }

  static get sessionSharingDomain(): boolean | undefined {
    return ConfigService.config.sessionSharingDomain || false;
  }

  static get googleAnalyticsKey(): string | undefined {
    return ConfigService.config.googleAnalyticsKey;
  }
  static get sessionCheckLoginPath(): string | undefined {
    return ConfigService.config.sessionCheckLoginPath || '';
  }

  static get encryption(): Encryption {
    return ConfigService.config.encryption;
  }
}
